import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { decryptData, encryptData, sendEmail, EmailTemplates, formatDateAndTime, showAlert } from "../../resources/constants";
import { toast } from "react-toastify";
import {  serverLink } from "../../resources/url";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../images/logo.png";
import {setApplicationDetails, setLoginDetails} from "../../actions/actions";

const ApplicantLogin=(props)=>{
    const navigate = useNavigate();
    const [formType, setFormType] = useState('Login')
    const [login, setLogin] = useState({
        EmailAddress: "",
        Password: "",
        RecoveryEmail: ""
    });

    const [dateline, setDateline] = useState([]);
    const [loading, setLoading] = useState(true);

    const getDateline = async () => {
        props.setOnApplicationDetails("");

        await axios
            .get(`${serverLink}application/dateline`)
            .then((res) => {
                setDateline(res.data.data[0]);
                setLoading(false);
            })
            .catch((err) => {
                console.log("NETWORK ERROR", err);
            });
    };

    useEffect(() => {
        getDateline();
    }, []);

    useEffect(() => {
        props.setOnLoginDetails("");
        props.setOnApplicationDetails("");
    }, []);


    const handleLogin = async (e) => {
        e.preventDefault();
        if (login.EmailAddress === "") {
            toast.error("Please enter your email address");
            return false;
        }

        if (login.Password === "") {
            toast.error("Please enter your password");
            return false;
        }

        await axios
            .post(`${serverLink}application/login`, login)
            .then((response) => {
                const data = response.data;
                if (data.message === "success") {
                    toast.success("Login Successful. Please wait...");
                    const dateOfBirth = data.data[0].DateOfBirth.split("T")[0];
                    const sendData = {
                        ...data.data[0],
                        DateOfBirth: dateOfBirth,
                    };
                    setTimeout(() => {
                        props.setOnLoginDetails(sendData);
                        // navigate('/application')
                        window.location.href = '/application';
                    }, 2000);
                } else toast.error("Invalid login credential!");
            })
            .catch((error) => {
                toast.error("Network error. Check your connection and try again!");
            });
    };

    const handleForgetPassword = async (e) => {
        e.preventDefault();
        toast.info("please wait...")
        const token = "pa" + Math.floor(Math.random() * 999999999);
        const email = EmailTemplates('2', encryptData(token));

        await axios.get(`${serverLink}application/registration/${login.RecoveryEmail}`, { token: encryptData(token) }).then(async (res) => {
            if (res.data.length > 0) {
                await axios.patch(`${serverLink}application/forget_password/add_token/${login.RecoveryEmail}`, { token: encryptData(token) })
                    .then((result) => {
                        if (result.data.message === "success") {
                            toast.success('An email have been sent to your mailbox, please check and proceed.')
                            sendEmail(
                                login.RecoveryEmail, email.subject, email.title, login.RecoveryEmail, email.body, '', ''
                            )
                        } else {
                            // toast.error('Please try again.')
                        }
                    }).catch((e) => {
                        console.log('NETWORK ERROR')
                    })
            } else {
                showAlert("Error", "The email provided is not registered", "error")
            }

        })

    }

    const onEdit = (e) => {
        if (e.target.id === "EmailAddress")
            setLogin({
                ...login,
                [e.target.id]: e.target.value,
            });
        else
            setLogin({
                ...login,
                [e.target.id]: encryptData(e.target.value),
            });

        if (e.target.id === "RecoveryEmail") {
            setLogin({
                ...login,
                RecoveryEmail: e.target.value
            })
        }
    };

    return(
        <>
        {formType === "Login" &&
            <div className="container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
                <div className="col-xl-12" style={{ maxWidth: "55rem", width: '40%' }}>
                        <div className="card-body">
                            <form className="login bg-white shadow p-5" onSubmit={handleLogin}>
                                <div className="text-center">
                                    <div className='container' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <img alt="Hensard University Logo" src={logo} style={{ height: '100px' }} />
                                    </div>
                                    <div className="mb-3">
                                        <h1 className="card-title" style={{ fontSize: "30px" }}>Sign In To Your Account </h1>
                                        <p>Sign in with email and password</p>

                                    </div>
                                </div>
                                <div className="row gy-4">
                                    <div className="col-sm-12">
                                        <label htmlFor="input-label" className="form-label">Email address</label>
                                        <input type="email" className="form-control"  onChange={onEdit} id="EmailAddress" placeholder="Enter email" />
                                    </div>
                                    <div className="col-sm-12">
                                        <label htmlFor="input-label" className="form-label">Password</label>
                                        <input type="password" className="form-control"  onChange={onEdit} id="Password" placeholder="Password" />
                                    </div>
                                    <button type="submit" className="btn btn-primary">
                                        Login
                                    </button>
                                    <p className="mt-3 mb-0">Don't have an account? <Link  to="/register" style={{color:"#007bff"}}>
                                        Register here
                                    </Link></p>
                                    <br />
                                    <span style={{ textDecoration: 'underline', cursor: 'pointer', color:"#007bff" }} onClick={() => {
                                        setFormType("ForgetPassword")
                                    }}>Forgot Password</span>
                                </div>
                            </form>
                        </div>
                </div>
            </div>
        }


            <section className="space-ptb">
                {formType === "ForgetPassword" &&
                    <div className="container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
                     <div className="col-xl-12" style={{ maxWidth: "55rem", width: '40%' }}>
                         <div className="card-body">
                             <form className="login bg-white shadow p-5" onSubmit={handleForgetPassword}>
                                 <div className="text-center">
                                     <div className='container' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                         <img alt="Hensard University Logo" src={logo} style={{ height: '100px' }} />
                                     </div>
                                     <div className="mb-3">
                                         <h1 className="card-title" style={{ fontSize: "30px" }}>Recover your password</h1>
                                     </div>
                                 </div>
                                 <div className="form-group">
                                     <label>Email address</label>
                                     <input type="email" className="form-control"  onChange={onEdit} id="RecoveryEmail" placeholder="Enter email" />
                                     <span className="focus-border" />
                                 </div>
                                 <br/>
                                 <button type="submit" className="btn btn-info">
                                     Reset Password
                                 </button>
                                 <p className="mt-3 mb-0">Not registered?<Link to="/register" style={{color:"#007bff"}}>
                                     Register here
                                 </Link></p>
                                 <br />
                                 <span style={{ textDecoration: 'underline', cursor: 'pointer', color:"#007bff" }} href="#" onClick={() => {
                                     setFormType("Login")
                                 }}>Login</span>
                             </form>
                         </div>
                     </div>
                    </div>
                }
            </section>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        applicationLogin: state.loginDetails,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
        setOnApplicationDetails: (p) => {
            dispatch(setApplicationDetails(p));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ApplicantLogin);

